import React, { useState, useEffect } from "react";
import AssetsTable from "./components/AssetsTable";
import Edit from "./modals/Edit";
import View from "./modals/View";
import Delete from "./modals/Remove";
import Create from "./modals/Create";
import Filter from "./modals/Filter";
import Divider from "@material-ui/core/Divider";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import axios from "axios";
import { v4 as uuid } from "uuid";
import { updateObject } from "../../../helpers/updateObject";

export default function Assets() {
  const [showEdit, setShowEdit] = useState(false);
  const [showView, setShowView] = React.useState(false);
  const [showRemove, setShowRemove] = useState(false);
  const [showCreate, setShowCreate] = useState(false);
  const [showFilter, setShowFilter] = React.useState(false);

  function handleChange() {
    setShowFilter((key) => !key);
  }

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setShowView(open);
  };

  const [error, setError] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [sortField, setSortField] = useState("id");
  const [orderBy, setOrderBy] = useState(false);
  const [rows, setRows] = useState([]);
  const [asset, setAsset] = useState({});
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);
  const [count, setCount] = useState(0);
  const [assetId, setAssetId] = useState(null);
  const [deleteAssetsIds, setDeleteAssetsIds] = useState([]);
  const [filter, setFilter] = useState(false);
  const [filterInputs, setFilterInputs] = useState({
    name: "",
    contactPerson: "",
    contactPersonPhoneNumber: "",
    contactPersonEmail: "",
  });

  const onAssets = (skip, take, sortField, orderBy) => {
    setIsLoaded(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}asset?Skip=${skip}&Take=${take}&SortField=${sortField}&OrderBy=${orderBy}`,
        {
          headers: {
            "Accept-Language": 1,
          },
        }
      )
      .then(
        ({ data: { data, totalCount } }) => {
          setIsLoaded(false);
          setRows(data);
          setCount(totalCount);
          setError(false);
        }
        ).catch((error) => {
          setIsLoaded(false);
          setError(true);
          setRows([]);
          setCount(0);
        });
  };
  const onFilter = (skip, take, sortField, orderBy, filterInputs) => {
    setIsLoaded(true);
    const { name, contactPerson, contactPersonPhoneNumber, contactPersonEmail } = filterInputs;
    axios
      .get(
        `${process.env.REACT_APP_API_URL}asset/filter?Skip=${skip}&Take=${take}&SortField=${sortField}&OrderBy=${orderBy}&Name=${name}&ContactPerson=${contactPerson}&ContactPersonPhoneNumber=${contactPersonPhoneNumber}&ContactPersonEmail=${contactPersonEmail}`,
        {
          headers: {
            "Accept-Language": 1,
          },
        }
      )
      .then(
        ({ data: { data, totalCount } }) => {
          setIsLoaded(false);
          setRows(data);
          setCount(totalCount);
          setError(false);
        },
        (error) => {
          setIsLoaded(false);
          setError(true);
          setRows([]);
          setCount(0);
        }
      );
  };

  const onAssetChoose = (id) => {
    axios
      .get(`${process.env.REACT_APP_API_URL}asset/${id}`)
      .then(({ data }) => {
        setAsset(data);
      });
  };

  const onUpdateUserStatus = (id, statusType) => {
    let isActive = !statusType;
    axios
      .patch(
        `${process.env.REACT_APP_API_URL}asset/active`,
        {
          id,
          isActive
        },
        {
          headers: {
            "x-requestid": uuid(),
          },
        }
      )
      .then(() => {
        onAssets(skip, take, sortField, orderBy);
      });
  };

  const onDeleteAssets = () => {
    axios
      .delete(`${process.env.REACT_APP_API_URL}asset`, {
        headers: {
          "x-requestid": uuid(),
        },
        data: {
          id: deleteAssetsIds,
        },
      })
      .then((res) => {
        setDeleteAssetsIds([]);
        onAssets(skip, take, sortField, orderBy);
      });
  };

  const filterInputsUpdate = (e) => {
    const updateFiltersInput = updateObject(filterInputs, {
      [e.target.name]: e.target.value,
    });

    setFilterInputs(updateFiltersInput);
    setSkip(0);
    setFilter(true);
  };
  useEffect(() => {
    if (filter) {
      const timer = setTimeout(() => {
        onFilter(skip, take, sortField, orderBy, filterInputs);
      }, 500);

      return () => clearTimeout(timer);
    } else {
      onAssets(skip, take, sortField, orderBy);
    }
  }, [skip, take, sortField, orderBy, filter, filterInputs]);

  useEffect(() => {
    if (!showView || !showEdit) setAsset({});
  }, [showView, showEdit]);


  const onAssetsExport = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}asset/export`, {
        responseType: "blob",
      })
      .then((res) => {
        var url = window.URL.createObjectURL(new Blob([res.data]));
        var a = document.createElement("a");
        a.href = url;
        a.download = "Assets.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
      });
  };


  return (
    <div className="row bg-white rounded">
      <div className="col-12 d-flex align-items-center py-4 fixed-title">
        <h1 className="display-4 mb-0">Asset list</h1>
        <FormControlLabel
          control={
            <Switch
              checked={showFilter}
              onChange={handleChange}
              color="secondary"
            />
          }
          label={showFilter ? "Hide filter" : "Show filter"}
          className="ml-auto mb-0"
        />
      </div>
      <Divider className="w-100" />
      <AssetsTable
        setSortField={setSortField}
        setOrderByTable={setOrderBy}
        sortField={sortField}
        orderBy={orderBy}
        setOpenEdit={setShowEdit}
        setOpenView={toggleDrawer(true)}
        setOpenRemove={setShowRemove}
        setOpenCreate={setShowCreate}
        isLoaded={isLoaded}
        error={error}
        rows={rows}
        onAssetChoose={onAssetChoose}
        updateSkip={setSkip}
        updateTake={setTake}
        count={count}
        onUpdateUserStatus={onUpdateUserStatus}
        setAssetId={setAssetId}
        setDeleteAssetsID={setDeleteAssetsIds}
        deleteAssetsIds={deleteAssetsIds}
        onDeleteAssets={onDeleteAssets}
        onAssetsExport={onAssetsExport}
      />
      <Edit
        asset={asset}
        show={showEdit}
        onHide={setShowEdit}
        skip={skip}
        take={take}
        sortField={sortField}
        orderBy={orderBy}
        onAssets={onAssets}
      />
      <View asset={asset} open={showView} onClose={toggleDrawer(false)} />
      <Delete
        id={assetId}
        show={showRemove}
        onHide={setShowRemove}
        skip={skip}
        take={take}
        sortField={sortField}
        orderBy={orderBy}
        onAssets={onAssets}
      />
      <Create
        show={showCreate}
        onHide={setShowCreate}
        onAssets={onAssets}
        skip={skip}
        take={take}
        sortField={sortField}
        orderBy={orderBy}
      />
      <Filter
        show={showFilter}
        onHide={handleChange}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
      />
    </div>
  );
}
